import { useCallback, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useAuth } from "./useAuth"
import { RootState } from "../redux/store"
import { centsClient } from "../api/cents/clients/cents-client"
import { setCharity } from "../redux/slices/session"
import { useNavigate } from "react-router-dom"

export function useAuthenticatedInitialization(): { initialized: boolean } {
  const currentCharityId = useSelector((state: RootState) => state.auth.currentCharityId)
  const charityId = useSelector((state: RootState) => state.auth.charity?._id)
  const [initialized, setInitialized] = useState<boolean>(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { isAuthenticated, logout } = useAuth()

  const initialize = useCallback(async () => {
    if (isAuthenticated) {
      try {
        await centsClient.initialize()
        if (currentCharityId && (!charityId || charityId !== currentCharityId)) {
          const charity = await centsClient.charities.getCharity(currentCharityId)
          dispatch(setCharity(charity))
        }
      } catch {
        logout()
        return
      }
      setInitialized(true)
    } else {
      navigate('/login')
    }
  }, [isAuthenticated, charityId, currentCharityId, dispatch, logout])

  useEffect(() => {
    if (!initialized) {
      void initialize()
    }
  }, [initialized])

  return { initialized }
}
